<script lang="ts">
  import { loginUser } from '../../../../components/auth/LoginUser';
  import type { IIenodenwaItem } from './types';
  import RepositoryFactory, { SUB_CONTRACT_HIKARI01_TEL } from '../../../../repositories/RepositoryFactory';

  export let ienodenwaItem: IIenodenwaItem;

  let pageStatus: 'TOP' | 'CONFIRM' | 'COMPLETE' = 'TOP';

  // ドロップダウンの選択肢
  // 全量
  const OPTION_CHANGES = [
    { code: 'NO_CHANGE', text: '変更しない' },
    { code: 'APPLY', text: '契約する' },
    { code: 'TERMINATE', text: '解約する' }
  ];

  // 契約済 の場合
  const SELECT_TERMINATE_OPTION_CHANGES = [
    { code: 'NO_CHANGE', text: '変更しない' },
    { code: 'TERMINATE', text: '解約する' }
  ];

  // 未契約 の場合
  const SELECT_APPLY_OPTION_CHANGES = [
    { code: 'NO_CHANGE', text: '変更しない' },
    { code: 'APPLY', text: '契約する' }
  ];

  type TOptionContractStatus = '契約中' | '未契約';
  interface IOptionItem {
    optionPack: TOptionContractStatus;
    numberDisplay: TOptionContractStatus;
    warikomi: TOptionContractStatus;
    warikomiDisplay: TOptionContractStatus;
  }

  const currentOptionItem: IOptionItem = {
    optionPack: ienodenwaItem.optionItem.optionPackFlg === 1 ? '契約中' : '未契約',
    numberDisplay: ienodenwaItem.optionItem.numberDisplayFlg === 1 ? '契約中' : '未契約',
    warikomi: ienodenwaItem.optionItem.warikomiFlg === 1 ? '契約中' : '未契約',
    warikomiDisplay: ienodenwaItem.optionItem.warikomiDisplayFlg === 1 ? '契約中' : '未契約'
  };

  type TOptionChangeCode = 'NO_CHANGE' | 'APPLY' | 'TERMINATE';
  interface IOptionChangeItem {
    optionPack: TOptionChangeCode;
    numberDisplay: TOptionChangeCode;
    warikomi: TOptionChangeCode;
    warikomiDisplay: TOptionChangeCode;
  }

  let optionChangeItem: IOptionChangeItem = {
    optionPack: 'NO_CHANGE',
    numberDisplay: 'NO_CHANGE',
    warikomi: 'NO_CHANGE',
    warikomiDisplay: 'NO_CHANGE'
  };

  interface IOptionChangeSelectItem {
    optionPack: any;
    numberDisplay: any;
    warikomi: any;
    warikomiDisplay: any;
  }
  const optionChangeSelectItem: IOptionChangeSelectItem = {
    optionPack: ienodenwaItem.optionItem.optionPackFlg ? SELECT_TERMINATE_OPTION_CHANGES : SELECT_APPLY_OPTION_CHANGES,
    numberDisplay: ienodenwaItem.optionItem.numberDisplayFlg
      ? SELECT_TERMINATE_OPTION_CHANGES
      : SELECT_APPLY_OPTION_CHANGES,
    warikomi: ienodenwaItem.optionItem.warikomiFlg ? SELECT_TERMINATE_OPTION_CHANGES : SELECT_APPLY_OPTION_CHANGES,
    warikomiDisplay: ienodenwaItem.optionItem.warikomiDisplayFlg
      ? SELECT_TERMINATE_OPTION_CHANGES
      : SELECT_APPLY_OPTION_CHANGES
  };

  const handleTransitionConfirm = (): void => {
    pageStatus = 'CONFIRM';
  };

  const handleTransitionComplete = async () => {
    const contractRepository = RepositoryFactory[SUB_CONTRACT_HIKARI01_TEL];
    await contractRepository
      .changeIenodenwaOption({
        opOptionPack: optionSelectedItem.optionPack,
        opSenderNumberDisplay: optionSelectedItem.numberDisplay,
        opWarikomi: optionSelectedItem.catchCall,
        opWarikomiDisplay: optionSelectedItem.catchCallNumberDisplay,
        contentsEntered: getContentsEntered()
      })
      .then((res) => {
        pageStatus = 'COMPLETE';
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生しました。再度やり直してください。');
        }
      });
  };

  $: optionSelectedItem = {
    optionPack: OPTION_CHANGES.find((o) => o.code === optionChangeItem.optionPack).text,
    numberDisplay: OPTION_CHANGES.find((o) => o.code === optionChangeItem.numberDisplay).text,
    catchCall: OPTION_CHANGES.find((o) => o.code === optionChangeItem.warikomi).text,
    catchCallNumberDisplay: OPTION_CHANGES.find((o) => o.code === optionChangeItem.warikomiDisplay).text
  };

  $: getContentsEntered = () => {
    return `・オプションパック：${optionSelectedItem.optionPack}
・着信番号表示：${optionSelectedItem.numberDisplay}
・キャッチ通話：${optionSelectedItem.catchCall}
・キャッチ通話番号表示：${optionSelectedItem.catchCallNumberDisplay}`;
  };
</script>

{#if pageStatus === 'TOP'}<!-- トップ画面 -->
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>いえのでんわオプションの変更</p>
          <p>変更するオプションの内容を選択し、「手続きへ」を押下してください。</p>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-items-center items-center">
      <div class="w-11/12 content-center p-4">
        <div class="inline-grid grid-cols-4 items-center min-w-full p-2">
          <div class="grid-1 col-span-2 w-full" />
          <div class="grid-1 justify-self-start w-full">
            <span class="label-title">現在の契約状況</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <span class="label-title">変更内容を指定ください</span>
          </div>
        </div>

        <div class="inline-grid grid-cols-4 items-center min-w-full p-2">
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <span class="label-title">オプションパック(660円)</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <span class="label-value">{currentOptionItem.optionPack}</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <select class="form-select text-sm" bind:value={optionChangeItem.optionPack}>
              {#each optionChangeSelectItem.optionPack as option}
                <option value={option.code}>{option.text}</option>
              {/each}
            </select>
          </div>
        </div>

        <div class="inline-grid grid-cols-4 items-center min-w-full p-2">
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <span class="label-title">着信番号表示(440円)</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <span class="label-value">{currentOptionItem.numberDisplay}</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <select class="form-select text-sm" bind:value={optionChangeItem.numberDisplay}>
              {#each optionChangeSelectItem.numberDisplay as option}
                <option value={option.code}>{option.text}</option>
              {/each}
            </select>
          </div>
        </div>

        <div class="inline-grid grid-cols-4 items-center min-w-full p-2">
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <span class="label-title">キャッチ通話(330円)</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <span class="label-value">{currentOptionItem.warikomi}</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <select class="form-select text-sm" bind:value={optionChangeItem.warikomi}>
              {#each optionChangeSelectItem.warikomi as option}
                <option value={option.code}>{option.text}</option>
              {/each}
            </select>
          </div>
        </div>

        <div class="inline-grid grid-cols-4 items-center min-w-full p-2">
          <div class="grid-1 col-span-2 justify-self-start w-full">
            <span class="label-title">キャッチ通話番号表示(110円)</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <span class="label-value">{currentOptionItem.warikomiDisplay}</span>
          </div>
          <div class="grid-1 justify-self-start w-full">
            <select class="form-select text-sm" bind:value={optionChangeItem.warikomiDisplay}>
              {#each optionChangeSelectItem.warikomiDisplay as option}
                <option value={option.code}>{option.text}</option>
              {/each}
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>※オプションパックをご契約すると自動的に他のオプションが契約となります</p>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleTransitionConfirm}> 手続きへ </button>
      </div>
    </div>
  </div>
{:else if pageStatus === 'CONFIRM'}<!-- いえのでんわ解約 確認 -->
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>いえのでんわオプションの変更</p>
          <p>以下の内容でお手続きを進めます。問題なければ実行ボタンを押下ください。</p>
          <ul class="list-disc mt-4 ml-4">
            <li>
              <p>オプションパック(660円)：{optionSelectedItem.optionPack}</p>
            </li>
            <li>
              <p>着信番号表示(440円)：{optionSelectedItem.numberDisplay}</p>
            </li>
            <li>
              <p>キャッチ通話(330円)：{optionSelectedItem.catchCall}</p>
            </li>
            <li>
              <p>
                キャッチ通話番号表示(110円)：{optionSelectedItem.catchCallNumberDisplay}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click|once={handleTransitionComplete}> 実行 </button>
      </div>
    </div>
  </div>
{:else if pageStatus === 'COMPLETE'}<!-- いえのでんわ解約 完了 -->
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="m-10">
      <div class="inline-flex justify-items-center items-center min-w-full mb-20">
        <div class="mb:font-sm w-full">
          <ul class="list-none mt-4">
            <li>
              <p>いえのでんわのオプション変更を受け付けました</p>
            </li>
            <li>
              <p>
                なお、いえのでんわのオプション変更手続きが完了するまでに数日のお時間をいただく場合がある点ご了承ください。
              </p>
            </li>
            <li class="mt-6">
              <p>お手続きについてご不明な点がございましたら、以下からご連絡いただくようお願いいたします。</p>
            </li>
            <li>
              <p>URL：https://bb01.unext.co.jp/contact</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
{/if}

<style lang="postcss">
  p:not([class]) {
    @apply tracking-normal mb-1;
  }
  .label-title {
    @apply text-sm font-medium text-gray-700;
  }
  .label-value {
    @apply text-sm font-medium text-gray-900;
  }

  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
  select {
    @apply rounded border py-2 px-3 focus:outline-none focus:ring-2 focus:ring-green-200 w-full;
  }
</style>
